var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTypeCourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 1.78564H8.57146C8.11681 1.78564 7.68077 1.97378 7.35928 2.30867C7.03779 2.64355 6.85718 3.09776 6.85718 3.57136V17.8571C6.85718 18.3307 7.03779 18.7849 7.35928 19.1198C7.68077 19.4547 8.11681 19.6428 8.57146 19.6428H18.8572C19.3118 19.6428 19.7479 19.4547 20.0694 19.1198C20.3909 18.7849 20.5715 18.3307 20.5715 17.8571V7.14279L15.4286 1.78564Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 3.57153H6.85711C6.40245 3.57153 5.96642 3.75967 5.64492 4.09456C5.32343 4.42944 5.14282 4.88365 5.14282 5.35725V19.643C5.14282 20.1166 5.32343 20.5708 5.64492 20.9057C5.96642 21.2405 6.40245 21.4287 6.85711 21.4287H17.1428C17.5975 21.4287 18.0335 21.2405 18.355 20.9057C18.6765 20.5708 18.8571 20.1166 18.8571 19.643V8.92868L13.7143 3.57153Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.35693H5.14287C4.68822 5.35693 4.25218 5.54507 3.93069 5.87996C3.6092 6.21484 3.42859 6.66905 3.42859 7.14265V21.4284C3.42859 21.902 3.6092 22.3562 3.93069 22.6911C4.25218 23.0259 4.68822 23.2141 5.14287 23.2141H15.4286C15.8832 23.2141 16.3193 23.0259 16.6408 22.6911C16.9623 22.3562 17.1429 21.902 17.1429 21.4284V10.7141L12 5.35693Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTypeCourse);
export default __webpack_public_path__ + "static/media/ic_type_course.8f4d0a6b.svg";
export { ForwardRef as ReactComponent };